import { render } from "./VabeneMarketingSettingsPage.vue?vue&type=template&id=07556a84&ts=true"
import script from "./VabeneMarketingSettingsPage.vue?vue&type=script&lang=ts"
export * from "./VabeneMarketingSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__